import React, { FC } from 'react'
import { TabListProps, Tab } from '../../Tabs/src/Tabs.types'
import { Tabs } from '../../Tabs/src/Tabs'

export const Commitments: FC<TabListProps> = props => {
  const { content, testId } = props

  if (!content.tab || content.tab.length < 2 || content.tab.length > 4) {
    console.error('Invalid commitments tab length')
    return null
  }

  return <Tabs content={content} testId={testId} type={`Commitments`} />
}
